import api from '@http/api';

export interface IDoacoes {
  modelo: IDoacoesResultTable[];
  idDoacao: number;
  dataCadastro: string;
  IDCadastro: number;
  NomeCadastro: string;
  Valor: string;
  origemDoacaoDescricao: string;
}

export interface IDoacoesResultTable {
  idDoacao: string;
  IDCadastro: string;
}

export interface ILoteParams {
  id_lote?: number;
  usuarioId?: number;
}

class Services {
  public async GetLotesReabertos(){
    return await api
      .get('/api/LoteDoacao/lotes-reabertos')
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }


  public async GetDoacoesPorLote(idLote: number) {
    return await api
      .get('/api/LoteDoacao/PendentesPorLote', {
        params: { idLote },
      })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async AprovarDoacoes(doacaoIds: number[], observacao: string) {
    return await api
      .post('/api/Doacao/AprovarDoacoes', { doacaoIds, observacao })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }

  public async RecusarDoacoes(doacaoIds: number[], observacao: string) {
    return await api
      .post('/api/Doacao/RecusarDoacoes', { doacaoIds, observacao })
      .then(response => {
        return { error: false, data: response.data };
      })
      .catch(() => {
        return { error: true, data: [] };
      });
  }



  public async FecharLote(id_lote: any) {
    return await api
    .post('/api/LoteDoacao/FecharLote', id_lote, {
      headers: { 'Content-Type': 'application/json' },
    })
      .then(() => {
        return { error: false };
      })
      .catch(() => {
        return { error: true };
      });
  }

   public async gerarRelatorio(idLote: number): Promise<{ error: boolean; response?: Blob }> {
    return await api
      .get(`/api/LoteDoacao/LotePdfFechado`, {
        params: { idLote },
        responseType: 'blob',
      })
      .then(response => ({
        error: false,
        response: response.data,
      }))
      .catch(() => ({ error: true }));
  }
}

export default new Services();
